__turbopack_context__.v({
  "content": "LvacFa_content",
  "left": "LvacFa_left",
  "resizer": "LvacFa_resizer",
  "right": "LvacFa_right",
  "sidebar": "LvacFa_sidebar",
});
